import { ReactNode, useCallback } from 'react'
import { Select } from '../../atoms'
import { FormItem } from './Component'

interface FormSelectProps {
  name: string
  label?: string
  children: ReactNode
  initialValue?: string | number
  info?: string
  ignoreErrorKeys?: string[]
  [key: string]: any
}

interface ComponentProps {
  onChange?: (value?: string | number) => void
  [key: string]: any
}

export const FormSelect = ({
  name,
  label,
  children,
  initialValue,
  info,
  ignoreErrorKeys,
  ...props
}: FormSelectProps) => {
  const Component = useCallback(
    ({ onChange, ...field }: ComponentProps) => (
      <Select onSelect={onChange || (() => {})} {...field} {...props}>
        {children}
      </Select>
    ),
    [],
  )

  return (
    <FormItem
      ignoreErrorKeys={ignoreErrorKeys}
      info={info}
      initialValue={initialValue}
      label={label}
      name={name}
    >
      <Component />
    </FormItem>
  )
}
